
function About() {
  return (
    <>
      <section className="section">
        <h1 className="hero-title">About</h1>
        <p>
          I'm a writer, actor, and software engineer based in New York City.
          I'm drawn to stories that explore the absurd, the poignant, and the political,
          whether through naturalist comedy or genre fiction.
        </p>
        <p>
          A while ago, I created the podcast{' '}
          <em>Thomas Tells a Story</em>
          , an anthology of original fiction. In 2021, I produced{' '}
          <a href="https://www.romans.nyc" target="_blank" rel="noopener noreferrer">
            <em>Romans</em>
          </a>
          , a play at Dixon Place in the Lower East Side.
        </p>
        <p>
          Today, I am focused on nurturing my creative network,
          and choosing smaller projects to produce with a higher level of quality and consistency.
        </p>
        <p>
          That said, I am currently working on a fantasy novel. It is called <em>Perastria</em>.
        </p>
      </section>

    </>
  );
}

export default About;
